import { Observable } from 'rxjs';

export abstract class RemoteConfigRepository {
  abstract getFeatureFlag(featureFlagName: string): Observable<boolean>;
  abstract getFeatureAttribute(featureAttributeName: string): Observable<any>;
  abstract getRemoteConfig(): Observable<{ [property: string]: any }>;
}
